import React from "react";

const Refer = () => {
  return (
    <div className="refer-section ">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <h2>Everything’s better with friends!</h2>
            <p>Earn passive income as you refer your friends to use Ileero</p>
            <div className="btn btn-primary">Refer Friends</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;
